// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Drag: React.FC = () => {
    return <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 11 17" enableBackground="new 0 0 11 17" xmlSpace="preserve">
<path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M2.1,13.6c0.94,0,1.7,0.76,1.7,1.7S3.04,17,2.1,17s-1.7-0.76-1.7-1.7
   S1.16,13.6,2.1,13.6z M8.9,13.6c0.94,0,1.7,0.76,1.7,1.7S9.84,17,8.9,17s-1.7-0.76-1.7-1.7S7.96,13.6,8.9,13.6z M2.1,6.8
   c0.94,0,1.7,0.76,1.7,1.7s-0.76,1.7-1.7,1.7S0.4,9.44,0.4,8.5S1.16,6.8,2.1,6.8z M8.9,6.8c0.94,0,1.7,0.76,1.7,1.7
   s-0.76,1.7-1.7,1.7S7.2,9.44,7.2,8.5S7.96,6.8,8.9,6.8z M2.1,0c0.94,0,1.7,0.76,1.7,1.7S3.04,3.4,2.1,3.4S0.4,2.64,0.4,1.7
   S1.16,0,2.1,0z M8.9,0c0.94,0,1.7,0.76,1.7,1.7S9.84,3.4,8.9,3.4S7.2,2.64,7.2,1.7S7.96,0,8.9,0z"/>
</svg>;
};

export default React.memo(Drag);
